(() => {
  const init = (section) => {
    if (!section || section.dataset.comoInitialized) return;
    section.dataset.comoInitialized = 'true';

    const reveal = () => section.classList.add('is-in');

    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              revealObserver.disconnect();
            }
          });
        },
        { threshold: 0.2 }
      );
      revealObserver.observe(section);
    } else {
      reveal();
    }
  };

  document.querySelectorAll('[data-como-funciona]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('[data-como-funciona]') || event.target;
    if (section?.matches?.('[data-como-funciona]')) {
      section.dataset.comoInitialized = '';
      init(section);
    }
  });
})();
